<div>
  <div
    class="container flex align-items-center top-border"
    *ngFor="let especialidade of data"
  >
    <p class="flex-grow-1">{{ especialidade }}</p>
    <div class="justify-content-end align-items-center mr-4">
      <ng-container *ngIf="delete">
        <p-button [rounded]="true" [text]="true" severity="danger">
          <ng-template pTemplate="icon">
            <div class="flex">
              <split-icon name="trash"></split-icon>
            </div>
          </ng-template>
        </p-button>
      </ng-container>

      <ng-container *ngIf="!delete">
        <p-button [rounded]="true" [text]="true" severity="secondary-orange">
          <ng-template pTemplate="icon">
            <div class="flex">
              <split-icon name="circle-plus"></split-icon>
            </div>
          </ng-template>
        </p-button>
      </ng-container>
    </div>
  </div>
  <div class="top-border"></div>
  <ng-container *ngIf="delete">
    <div class="flex align-items-center justify-content-center">
      <img
        src="/assets/lista-unidade/circle-plus.svg"
        alt="imagem de um circulo com um + no centro simbolizando adicionar"
        class="cursor-pointer"
        (click)="adicionarEspecialidade()"
      />
      <p
        class="underline ml-1 cursor-pointer"
        (click)="adicionarEspecialidade()"
      >
        Adicionar
      </p>
    </div>
  </ng-container>
  <ng-container *ngIf="!delete">
    <div class="h-4rem mt-2">

    </div>
  </ng-container>
</div>
